var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7773 46.31C23.7773 42.5817 26.5965 39.5803 30.0983 39.5803C33.6002 39.5803 36.4193 42.5817 36.4193 46.31V62.8752C36.4193 66.6034 33.6002 69.6049 30.0983 69.6049C26.5965 69.6049 23.7773 66.6034 23.7773 62.8752V46.31Z",
    fill: "#E01E5A",
    stroke: "#E01E5A",
    strokeWidth: 0.790123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3117 52.2222C42.5835 52.2222 39.582 49.4031 39.582 45.9012C39.582 42.3994 42.5835 39.5803 46.3117 39.5803H62.8771C66.6053 39.5803 69.6067 42.3994 69.6067 45.9012C69.6067 49.4031 66.6053 52.2222 62.8771 52.2222H46.3117Z",
    fill: "#ECB22D",
    stroke: "#ECB22D",
    strokeWidth: 0.790123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.582 13.1247C39.582 9.39652 42.4012 6.39508 45.903 6.39508C49.4048 6.39508 52.224 9.39652 52.224 13.1247V29.69C52.224 33.4183 49.4048 36.4198 45.903 36.4198C42.4012 36.4198 39.582 33.4183 39.582 29.69V13.1247Z",
    fill: "#2FB67C",
    stroke: "#2FB67C",
    strokeWidth: 0.790123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1242 36.4197C9.39597 36.4197 6.39453 33.6006 6.39453 30.0988C6.39453 26.5969 9.39597 23.7778 13.1242 23.7778H29.6895C33.4178 23.7778 36.4192 26.5969 36.4192 30.0988C36.4192 33.6006 33.4178 36.4197 29.6895 36.4197H13.1242Z",
    fill: "#36C5F1",
    stroke: "#36C5F1",
    strokeWidth: 0.790123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5781 63.2839C39.5764 64.1145 39.7387 64.9372 40.0557 65.7049C40.3727 66.4726 40.8383 67.1701 41.4256 67.7575C42.0129 68.3448 42.7104 68.8103 43.4781 69.1273C44.2458 69.4444 45.0685 69.6066 45.8991 69.6049C49.401 69.6049 52.2201 66.7857 52.2201 63.2839C52.2219 62.4533 52.0596 61.6306 51.7426 60.8629C51.4255 60.0952 50.96 59.3976 50.3727 58.8103C49.7854 58.223 49.0879 57.7575 48.3202 57.4405C47.5525 57.1234 46.7297 56.9611 45.8991 56.9629H39.5781V63.2839Z",
    fill: "#ECB22D",
    stroke: "#ECB22D",
    strokeWidth: 0.790123,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2819 36.4197H56.9609V30.0988C56.9609 26.5969 59.7801 23.7778 63.2819 23.7778C66.7838 23.7778 69.6029 26.5969 69.6029 30.0988C69.6029 33.6006 66.7838 36.4197 63.2819 36.4197Z",
    fill: "#2FB67C",
    stroke: "#2FB67C",
    strokeWidth: 0.790123,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7155 39.5802H19.0365V45.9012C19.0365 49.403 16.2174 52.2222 12.7155 52.2222C11.885 52.2239 11.0622 52.0617 10.2945 51.7446C9.52681 51.4276 8.82928 50.9621 8.24197 50.3747C7.65466 49.7874 7.18913 49.0899 6.8721 48.3222C6.55506 47.5545 6.39277 46.7318 6.39455 45.9012C6.39455 42.3994 9.21371 39.5802 12.7155 39.5802Z",
    fill: "#E01E5A",
    stroke: "#E01E5A",
    strokeWidth: 0.790123,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4193 12.716V19.037H30.0983C29.2678 19.0388 28.445 18.8765 27.6773 18.5595C26.9096 18.2424 26.2121 17.7769 25.6248 17.1896C25.0375 16.6023 24.5719 15.9047 24.2549 15.137C23.9379 14.3694 23.7756 13.5466 23.7774 12.716C23.7774 9.21419 26.5965 6.39503 30.0983 6.39503C30.9289 6.39326 31.7517 6.55555 32.5194 6.87258C33.2871 7.18962 33.9846 7.65515 34.5719 8.24246C35.1592 8.82977 35.6247 9.52729 35.9418 10.295C36.2588 11.0627 36.4211 11.8854 36.4193 12.716Z",
    fill: "#36C5F1",
    stroke: "#36C5F1",
    strokeWidth: 0.790123,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.f98e1f5cc674cbf34bb29eb081f7e523.svg";
export { ForwardRef as ReactComponent };